// extracted by mini-css-extract-plugin
export var addToCartButton = "_oh-b";
export var arrowButtonContainer = "_oh-9";
export var arrowButtonIcon = "_oh-a";
export var carouselArrowButton = "_oh-6";
export var carouselElementContainer = "_oh-1";
export var galleryThumbnail = "_oh-d";
export var galleryThumbnailImage = "_oh-e";
export var left = "_oh-7";
export var productDisplayCarouselContainer = "_oh-0";
export var productTileContainer = "_oh-2";
export var productTileImage = "_oh-4";
export var productTileImageContainer = "_oh-3";
export var productTileTitle = "_oh-5";
export var right = "_oh-8";
export var sliderOverflow = "_oh-c";